<script setup>
import { RouterLink } from 'vue-router';



</script>

<template>
    <div class="container">
        <div class="image"> </div>
        <div class="content">
            <header>
                <h1
                    style="color: var(--color-primary); font-size: var(--font-size-xl); margin-bottom: var(--spacing-sm);">
                    Der Ablauf
                </h1>
                <h2
                    style="color: var(--color-accent); font-size: var(--font-size-lg); margin-bottom: var(--spacing-xl);">
                    Kann KI bei Lese-Rechtschreib-Schwäche/Störung helfen?
                </h2>
            </header>


            <section style="margin-top: var(--spacing-xl);">
                <h3
                    style="color: var(--color-primary); border-bottom: 1px solid var(--color-ui-neutral); padding-bottom: var(--spacing-sm); margin-bottom: var(--spacing-md);">
                    Ablauf
                </h3>
                <p style="margin-bottom: var(--spacing-lg);">
                    Der Test besteht aus einer Reihe von Durchgängen mit jeweils drei kurzen Szenarien.
                </p>

                <div
                    style="background-color: var(--color-background-light); padding: var(--spacing-md); border-radius: var(--border-radius-base); margin-bottom: var(--spacing-md);">
                    <h4 style="color: var(--color-text-dark); margin-top: 0; margin-bottom: var(--spacing-sm);">
                        1️⃣ Szenario 1: Sätze schreiben (Diktat)
                    </h4>
                    <p style="font-size: var(--font-size-base);">
                        Es werden 5 Sätze in aufsteigender Schwierigkeit diktiert und müssen aufgeschrieben werden.
                    </p>
                </div>

                <div
                    style="background-color: var(--color-background-light); padding: var(--spacing-md); border-radius: var(--border-radius-base); margin-bottom: var(--spacing-md);">
                    <h4 style="color: var(--color-text-dark); margin-top: 0; margin-bottom: var(--spacing-sm);">
                        2️⃣ Szenario 2: Wörter schreiben (Diktat)
                    </h4>
                    <p style="font-size: var(--font-size-base);">
                        Es werden 10 Wörter in aufsteigender Schwierigkeit diktiert.
                    </p>
                </div>

                <div
                    style="background-color: var(--color-background-light); padding: var(--spacing-md); border-radius: var(--border-radius-base);">
                    <h4 style="color: var(--color-text-dark); margin-top: 0; margin-bottom: var(--spacing-sm);">
                        3️⃣ Szenario 3: Wörter korrigieren
                    </h4>
                    <p style="font-size: var(--font-size-base);">
                        Auf einem Blatt stehen **10 falsch geschriebene Worte**, die korrigiert werden müssen.
                    </p>
                </div>

                <RouterLink style="margin-top: var(--spacing-xl); text-align: center;" to="/canvas">
                    <strong style="color: var(--color-primary);">Bist du bereit, mit dem ersten Szenario zu
                        starten?</strong>
                </RouterLink>

            </section>
        </div>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
    width: 100%;
    height: 92%;

    display: flex;
    overflow: hidden;


    .image {
        width: 50%;
        background-image: url(./../../assets/welcome.png);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .content {
        width: 100%;
        padding: var(--spacing-lg);
        overflow: scroll;
    }

}
</style>
